/* PATOYS collection: "Load more". Without JavaScript the link goes to the next page and normal pagination works. */
(function () {
  var root = document.querySelector('.pt-collection');
  if (root) root.classList.add('pt-has-loadmore');

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pt-loadmore]');
    if (!btn) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var url = btn.getAttribute('href');
    var wrap = btn.closest('[data-pt-loadmore-wrap]');
    var list = document.querySelector('#product-grid');
    if (!url || !wrap || !list) {
      window.location.href = url;
      return;
    }

    btn.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('bad response');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        if (!items.length) throw new Error('no items');
        items.forEach(function (li) {
          list.appendChild(document.importNode(li, true));
        });
        var nextWrap = doc.querySelector('[data-pt-loadmore-wrap]');
        if (nextWrap) {
          wrap.replaceWith(document.importNode(nextWrap, true));
        } else {
          wrap.remove();
        }
      })
      .catch(function () {
        window.location.href = url;
      });
  });
})();